/* eslint-disable */
<!-- 新增模块 -->
<template>
    <div class="stems" id="stems">
        <!-- 地区筛选 -->
        <div class="addressFilter">
            <AddressFilter ref="addressFilterRef" :coilingId="coilingId" @updateModule="updateModule" @getForm="getForm" @getCollectionStatus="getCollectionStatus" from="special"/>
            <!-- <AddressSpecialFilter ref="addressFilterRef" :coilingId="coilingId" @getForm="getForm" @getCollectionStatus="getCollectionStatus" :moduleData="moduleSeletctData" from="special"/> -->
        </div>

        <!-- 内容 -->
        <div class="content">
            <div class="testLevel">
                <div class="testContentBox">
                    <el-container class="el-container-box">
                        <el-header>
                            <div class="levelBtnBox">
                                <p class="coilingTitle">试题层级     
                                </p>
                                <!-- <el-button icon="el-icon-circle-plus-outline" @click="addLevel1Node">添加层级</el-button> -->
                                <div class="addLevelBtn" @click="addLevel1Node">
                                    <img src="../assets/images/icon-add-lvl.png" />
                                    添加层级
                                    <div class="operateTwo" v-show="isShowLevelMenu">
                                        <div class="operateList" v-if="topLevel === 1||topLevel === 0" @click="insertLevelNode(1)">
                                            <i class="el-icon-caret-bottom" style="color: #FA80C6;"/>
                                            一级
                                        </div>
                                        <div class="operateList" v-if="topLevel === 2||topLevel === 0" @click="insertLevelNode(2)">
                                            <i class="el-icon-caret-bottom" style="color: #3987EF;"/>
                                            二级
                                        </div>
                                        <div class="operateList" v-if="topLevel === 3||topLevel === 0" @click="insertLevelNode(3)">
                                            <i class="el-icon-caret-bottom" style="color: #FCCA00;"/>
                                            三级
                                        </div>
                                        <div class="operateList" v-if="topLevel === 4||topLevel === 0" @click="insertLevelNode(4)">
                                            <i class="el-icon-caret-bottom" style="color: #333333;"/>
                                            四级
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </el-header>
                        <el-container class="testLevelTree">
                            <fl-Tree ref="testLevelTreeRef" 
                                :dateSourcea="testLevelTreeData" 
                                @afterToggle="afterToggle" 
                                @dbclick="headerDbClick"
                                @nodeClick="testLevelNodeClick"
                                @setNodeName="setNodeName"
                                default-expand-all>
                                <template #header="{node,data}">
                                    <div v-if="!data.isEdit" style="width:calc(100% - 20rem);display: flex;
                                        flex-direction: row;
                                        align-items: center;
                                        justify-content: space-between;position:relative">
                                        <span class="treeNodeName">
                                            {{ data.name }}
                                        </span>
                                        <div class="unsaved"  v-if="contentChangeId.includes(data.paperId)">*</div>
                                        <div class="optFields" v-show="node.isCheck" @click="handleOperate($event, data.id, data.lvl, data.name)"></div>
                                    </div>
                                    <div class="treeNodeBox" v-else>
                                        <input
                                            :ref="data.id"
                                            placeholder="请输入层级名称"
                                            v-model="data.name"
                                            @blur="($event) => treeInputBlur($event, data, node)"
                                            @keydown="($event) => handleEnter($event, data, node)"
                                            class="treeNodeEdit"
                                        />
                                          <!-- @keydown="($event) => handleEnter($event, data, node)" -->
                                            <!-- @blur="($event) => handleBlur($event, data, node)" -->
                                    </div>
                                </template>
                            </fl-Tree>
                            <!-- <el-tree ref="testLevelTreeRef" 
                            :data="testLevelTreeData" 
                            @node-click="testLevelNodeClick"  
                            :indent=8 :expand-on-click-node="false" 
                            default-expand-all 
                            node-key="id"
                            :props="testLevelProps"
                            :highlight-current="true">
                                <span class="custom-tree-node" slot-scope="{ node, data }" @dblclick="headerDbClick(data)">
                                    <span v-if="!data.isEdit">{{ node.label }}</span>
                                    <div v-else>
                                        <input
                                            :ref="data.id"
                                            placeholder="请输入层级名称"
                                            v-model="data.name"
                                            @keydown="($event) => handleEnter($event, data, node)"
                                            class="treeNodeEdit"
                                        />
                                          <div class="optFields" @click="handleOperate($event, data.id, data.lvl, data.name)"></div>
                                    </div>
                                </span>
                                
                            </el-tree> -->
                            
                        </el-container>
                        <div class="operateBox" v-if="isOperate" ref="operateBox"
                          :style="{ top: screenTop + lastScroll.y - scroll.y + 'px', left: screenLeft + lastScroll.x - scroll.x + 'px' }">
                          <OperateTestLevel  :optTestLevelId="optTestLevelId" :optTextLevelLabel="optTextLevelLabel" :optTestLevel="optTestLevel" @insertTreeLevelNode="insertTreeLevelNode" 
                          @addSpecialCoilingHandle="addSpecialCoilingHandle" :childLevel="childLevel" :showLevelArr="showLevelArr" />
                        </div>
                    </el-container>
                    
                </div>
                
            </div>
            <div class="contentProcessBox" v-show="!isEmpty">
                <!-- 试题内容 -->
                <div class="testContent">
                    <TestContent ref="testContentRef" @child-value="handleChildValue" :message="addlist"
                        :formData="formData" :collectionTestAllId="collectionTestAllId" :nowId="coilingId"
                        @getCollectionStatus="getCollectionStatus" from="special" />
                </div>

                <!-- 答题流程 -->
                <div class="answeringProcess">
                    <answeringProcess ref="answeringProcessRef" @update:fromGrandchild="handleDataFromGrandchild"
                        :nowId="coilingId" pageNum="2" />
                </div>
            </div>
            <div class="noData" v-show="isEmpty">
                <el-empty
                    description=" "
                    :image-size="300"
                    :image="require('./question/static/empty.png')"
                    v-if="true"
                    class="empty_img"
                ></el-empty>
            </div>
        </div>
        <div class="starDia">
            <el-dialog class="elDialog" :visible.sync="dialogVisible" ref="dialog" :title="dialogTitle" width="1300rem"
                @close="scjClose">
                <div class="dia_item">
                    <el-tabs v-show="tabsShow" @tab-click="handleClick" v-model="activeName">
                        <el-tab-pane v-for="(item, index) in tabsLsit" :key="index" :label="item.name"
                            :name="item.type">
                        </el-tab-pane>
                    </el-tabs>
                    <!-- eslint-disable -->
                    <div class="out">
                        <div class="mes-l">
                            <div class="search-container" @click="handleSearch">
                                <el-input placeholder="请输入你需要的名称" suffix-icon="el-icon-search" v-model="filterText"
                                    @input="handleSearch"></el-input>
                            </div>
                            <div style="display: flex;justify-content: space-between;margin: 10rem;">
                                <el-checkbox v-model="checked">我的收藏</el-checkbox>
                                <i class="el-icon-delete" style="cursor: pointer" @click="removeSelected"
                                    slot="reference"></i>
                            </div>

							<div>
								<el-tree ref="tree" :data="treeData" :props="defaultProps" show-checkbox
									default-expand-all node-key="id" @check-change="handleCheckChange"
									:default-checked-keys="defaultCheckedKeys" :filter-node-method="filterNode"
									@node-click="handleNodeClick">
									<template slot-scope="{ node, data }">
                                        <el-tooltip class="item" effect="light" :content="node.label" placement="right-start">
                                            <span class="tree-node-label">{{ node.label }}
											<i v-show="editable === data.id"
												style="position: absolute; right: 20rem; color: #07b972"
												class="el-icon-edit" @click="handleRename(node, data)"></i></span>
                                        </el-tooltip>
									</template>
								</el-tree>
							</div>
						</div>
						<div class="mes-r">
							<div class="r-t">
								<div ref="collectionContentRef">
                                    <el-form v-if="checkedCollectionContentList.length > 0" ref="form" class="addFields" style="padding-left: 10rem;padding-right: 0rem;height: auto;">
                                      <div ref="sortableRef">
                                        <div class="fieldsList" v-for="(items, index) in checkedCollectionContentList"
                                          :key="items.id" :id="items.id" :ref="items.id" style="margin-right: 10rem;margin-bottom:5rem">
                                          <!-- 选择题干 -->
                                          <div class="fieldsChoice">
                                            <el-dropdown>
                                              <span class="el-dropdown-link">
                                                {{ items.type }}<i class="el-icon-arrow-down el-icon--right"></i>
                                              </span>
                                            </el-dropdown>
                                          </div>
                                    
                                          <!-- 输入内容 -->
                                          <div class="fieldsContent" style="padding-top: 0rem;">
                                            <!-- 输入框 -->
                                            <div class="fieldsContentSelect">
                                              <!-- <el-input auto-complete="off" type="textarea" 
                                              :autosize="{
                                                minRows: textareaRows[items.typeId],
                                                maxRows: textareaRows[items.typeId] + 14,}"
                                                 v-model="items.value" v-if="!(items.typeId == 'option' || items.typeId == 'chart' || items.typeId == 'audio' || items.typeId == 'analysis') && items.typeId" 
                                                :style="{
                                                  'font-weight':
                                                    items.typeId == 'firstLevel' || items.typeId == 'secondLevel'
                                                      ? 600
                                                      : 500,
                                                }"
                                                 placeholder="请输入内容" readonly>
                                              </el-input> -->
                                              <div style="padding: 10rem" v-if="!(items.typeId == 'option' || items.typeId == 'chart' || items.typeId == 'audio' || items.typeId == 'analysis') && items.typeId">
                                                {{items.value}}
                                              </div>
                                              <div v-if="items.typeId == 'analysis'" class="quill_edit_box">
                                                <div class="quill_edit_mask"></div>
                                                <quill-edit :options="editorOption" :value="items.value" :arrayIndex="index"></quill-edit>
                                              </div>
                                              <div class="audio_item" v-if="items.typeId == 'audio' && items.hearLink">
                                                <el-upload class="upload-video"  :show-file-list="false" action="" :headers="customHeaders">
                                                  <i class="el-icon-video-play" style="color: #0BAE6A;font-size: 15rem;"></i> &nbsp;&nbsp;{{
                                                    parseTime(items.hearTime)
                                                  }}
                                                </el-upload>
                                              
                                              </div>
                                              <div class="audio_item" v-if="items.typeId == 'audio' && !items.hearLink">
                                                <el-upload class="upload-video"  :show-file-list="false" action="" disabled :headers="customHeaders">
                                                  <i class="el-icon-upload" style="color: #0BAE6A;font-size: 15rem;"></i> &nbsp;添加音频
                                                </el-upload>
                                              
                                              </div>
                                
    
                                              <!-- 选项 -->
                                              <Add-Select-Read-Only v-if="items.typeId == 'option'" :id="items.id"
                                                :selectListCopy="items.selectList" />
                                    
                                              <!-- 上传图片 -->
                                              <el-upload v-if="items.fileList.length === 0" class="uploadImg" :file-list="items.fileList" list-type="picture"
                                                 action="" disabled>
                                                <div class="uploadBtn">
                                                  <img src="../assets/images/icon-addImg.png" />
                                                  添加
                                                </div>
                                              </el-upload>
                                              <el-upload v-else class="uploadImg"  action="" :file-list="items.fileList" list-type="picture"
                                                :class="{ uploadImgBorder: items.fileList.length > 0 }" disabled>
                                                <div class="uploadBtn">
                                                  <img src="../assets/images/icon-addImg.png" />
                                                  添加
                                                </div>
                                              </el-upload>
                                            </div>
                                    
                                            <div class="fieldsContentBottom">
                                              <p class="idText">
                                                ID:
                                                <el-input v-model="items.fieldId" placeholder="ID" size="mini" maxlength="5" 
                                                  class="idTextInput" readonly></el-input>
                                              </p>
                                                <img class="copyId" src="../assets/images/icon-copy.png"  />
                                              <div class="queSelect idText idText1" >
                                                编号: <span style="width: 90rem;margin-left: 3rem;">{{items.que_num === '' ? "请选择" : items.que_num}}</span>
                                              </div>
                                              <div class="queSelect" v-if="items.typeId == 'hearing'">
                                                题目绑定:
                                                <el-input style="margin-left: 5rem;" v-model="items.bindNum" placeholder="输入题目ID" size="mini" class=""
                                                  readonly></el-input>
                                              </div>
                                              <div class="queSelect" v-if="items.typeId == 'chart'">
                                                题目绑定: {{items.bindNum === '' ? "输入题目ID" : items.bindNum}}
                                              </div>
                                              <div class="queSelect" v-if="items.typeId == 'subject'">
                                                <template v-if="items.hasAnswerMethod">
                                                  <div>作答方式:</div>
                                                  <span style="width: 90rem;margin-left: 5rem;">{{getAnswerMethodLabel(items.que_type)}}</span>
                                                </template>
                                                <template v-else>
                                                  <div>题目类型:</div>
                                                  <span style="width: 90rem;margin-left: 5rem;">{{getqueTypeMapLabel(items.que_type)}}</span>
                                                </template>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>                                                                                                    
                                    </el-form>
                                </div>
                                <div class="rt-item" v-for="(items, index) in checkedCollectionProgresslist"
                                  :key="items.id" :id="items.id" :ref="items.id" style="margin-top: 5rem;" contenteditable="false">
                                    <div class="progress_item" ref="progressItem">
                                        <div class="progress_id">绑定题目ID: <el-input class="display_input" v-model="items.bindId" size="small" readonly>
                                            </el-input></div>
                                        <div class="progress_item_head" style="padding-left: 0rem;">
                                            <el-input class="name_ipt" ref="nameIpt" placeholder="输入流程名称" v-model="items.name" maxlength=7
                                                style="width: 130rem" readonly>
                                            </el-input>
                                            <img class="timer" :src="timePath" />
                                            <el-input class="time_ipt" placeholder="00:00" v-model="items.time" maxlength=5
                                                :disabled="timeDisabled" readonly>
                                            </el-input>
                                        </div>
                                        <!--添加音频环节-->
                                        <div class="progress_item_audio" v-if="items.audioUrl != ''">
                                            <span>音频:</span>
                                            <div class="audio_item">
                                                <img src="@/assets/images/icon-audio.png" />
                                                <span>{{ items.audioDuration ? items.audioDuration : '00:00' }}</span>
                                            </div>
                                            <p>替换</p>
                                            <p>删除</p>                                                                          
                                            <el-dropdown class="play_times">
                                                <el-button plain style="top:0rem;font-size:14rem;margin-top:2rem">
                                                    播放<span style="color:#FFB802;">{{ items.playTimes }}</span>次<i
                                                        class="el-icon-arrow-down el-icon--right"></i>
                                                </el-button>
                                            </el-dropdown>
                                    
                                            <el-dropdown class="play_setting">
                                                <el-button plain style="top:0rem;font-size:14rem;margin-top:2rem">
                                                    设置<i class="el-icon-arrow-down el-icon--right"></i>
                                                </el-button>
                                            </el-dropdown>
                                        </div>
                                        <!--添加录音环节-->
                                        <div class="progress_item_show" v-if="items.display == 'showRecord'">
                                            <div>录音环节</div>
                                            <div class="del_diy" >删除</div>
                                        </div>
                                        <!--添加显示环节-->
                                        <div class="progress_item_show" v-if="items.display == 'showAnser'">
                                            <div>答案材料展示</div>
                                            <div class="del_diy" >删除</div>
                                        </div>
                                        <!--添加显示环节-->
                                        <div class="progress_item_show" v-if="items.displays.length > 0">
                                            <div class="showLeft">显示:</div>
                                            <div class="showRight">
                                                <el-input class='display_input' ref='displayInput' placeholder="内容ID" v-model="item.content"
                                                    maxlength=10 v-for="(item, index) in items.displays" :key="index" 
                                                     readonly>
                                                </el-input>
                                                <img src="@/assets/images/icon-addSelect.png" style="cursor:pointer"/>
                                            </div>
                                    
                                        </div>
                                        <!--添加输入环节-->
                                        <div class="progress_item_input" v-if="items.inputs.length > 0">
                                            <div class="input_left" style="margin-top:6rem;">输入:</div>
                                            <div class="input_right">
                                                <el-input placeholder="点击输入" v-model="item.content" maxlength=10
                                                    v-for="(item, index) in items.inputs" :key="item.id" readonly
                                                    >
                                                    <template slot="prepend" >
                                                        <div class="input_prepend" ref='inputPrepend'>
                                                            {{ item.number ? item.number : '序号'}}
                                                        </div>
                                                    </template>
                                                    <template slot="suffix">
                                                        <i class="el-icon-error"></i>
                                                    </template>
                                                </el-input>
                                                <img src="@/assets/images/icon-addSelect.png" style="cursor:pointer" />
                                            </div>
                                        </div>
                                        <!--操作环节-->
                                        <div class="progress_item_option" v-if="optionVisible && isPractise && optionNotEmpty">
                                            <div class="operation" style="margin-top:-2rem;">操作:</div>
                                            <div class="operation_right">
                                                <el-checkbox-group v-model="items.options">
                                                    <el-checkbox disabled v-for="(item, index) in options" :key="index" :label="item">{{ item }}</el-checkbox>
                                                </el-checkbox-group>
                                            </div>
                                        </div>
                                    </div>
                                </div>
							</div>
							<div class="r-b">
								<span>已选择<span style="color: #07b972">{{ selectedIds.length}}</span>个</span>
                                <span class="btn" @click="insertList">确定插入</span>
							</div>
						</div>
					</div>
				</div>
			</el-dialog>
			<el-dialog :visible.sync="isRenaming" width="400rem" style="border-radius: 10rem;height:380rem" title="重命名">
				<el-input v-model="newName" placeholder="请输入" style="width: 350rem;"></el-input>
				<div @click="finishRename" class="btn" style="margin: 20rem 0 0 230rem; width: 120rem;height:40rem;line-height:40rem;">
					确定
				</div>
			</el-dialog>
			<el-dialog class="dialog" :title="dialogTitle" :visible.sync="dialogVisible2" width="500rem"
				style="border-radius: 10rem" @close="closeSelectPaper">
				<div class="search-container" @click="handleSearch2">
                    <el-input placeholder="请输入你需要的名称" suffix-icon="el-icon-search" v-model="filterText2"
                    @input="handleSearch2"></el-input>
				</div>
				<div style="margin: 10rem 0 0 5rem">
					已选择<span style="color: #07b972">{{
            multipleSelection.length
          }}</span>/{{ filterPapersData.length }}个
				</div>
				<el-table ref="multipleTable" :data="filterPapersData" tooltip-effect="dark" max-height="300" style="
            width: 100%;
            border: 1rem solid #ccc;
            margin: 10rem auto;
            border-radius: 5rem;
          " @selection-change="handleSelectionChange">
					<el-table-column prop="id" type="selection" width="55" align="center"> </el-table-column>
					<el-table-column prop="name" label="名称" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{scope.row.paperName}}-{{scope.row.type}}
                            <!-- -{{scope.row.year}} -->
                        </template>
					</el-table-column>
				</el-table>
				<div class="btn" @click="insertCollections2Papers" style="width: 40rem; margin: 10rem; margin-left: 360rem">
					确定
				</div>
			</el-dialog>
		</div>
		<div class="favorite" @click="favoritesShow()">
			<i class="el-icon-star-on" style="font-size: 16rem"></i>
			<p>收藏夹</p>
		</div>
        <TestPreview ref="addCoilingRef"></TestPreview>
	</div>
</template>

<script>
    import AddSelectReadOnly from "@/components/testContent/addFields/AddSelectReadOnly.vue";
    import OperateTestLevel from "./special/operateTestLevelFrame.vue";
    import { EventBus } from "@/utils/event-bus.js";
	import TestContent from "../components/testContent/TestContent";
	import AddressFilter from "../components/addModule/addressFilter.vue";
    import TestPreview from "./special/components/testPreview.vue";
    import flTree from '../components/flTree/index'
    // import AddressSpecialFilter from "../components/addModule/addressSpecialFilter.vue";
    import { getToken } from '@/utils/auth';
    import { getModuleType,queTypeMap,answerMethodMap } from "@/utils/util.js";
        import _ from "lodash";
	import {
		getAllCoiling,
		addRefiningCoiling,
		// getList,
        getCollectList,
		deleteStar,
		reName,
		getCollectionStatus,
        getPapersByRegion,
	} from "@/api/addModule";
    import {
        addTestLevel,
        delTestLevel,
        renameTestLevel,
        getTestLevelTree,
        updateModuleInfo
    } from "@/api/special";
	import answeringProcess from "../components/answeringProcess/indexFour.vue";
    import { uploadAudio } from "@/constants/constants";
	const TAG = "[AddModule.vue] ";
    import quillEdit from '../components/quillEdit/quillEdit'

	export default {
		name: "AddModule",
		components: {
			TestContent, // 试题内容
			AddressFilter, // 地区筛选
            // AddressSpecialFilter,   // 地区筛选
			answeringProcess, //答题流程
            AddSelectReadOnly,
            OperateTestLevel,
            TestPreview,
            flTree,
            quillEdit
		},
		data() {
			return {
                customHeaders:{
                    'Authorization':getToken()
                },
				bookId: undefined,
                catalogId: '',
				dialogVisible: false,
				dialogTitle: "收藏夹",
				activeName: 'test_single',
				tabsShow: true,
				lanweiList: [],
				isOperate: false,
				addlist: [],
				enable: false,
				isRenaming: false, // 是否正在重命名
				newName: "", // 新的节点名称
				selectId: "", // 节点id
				renamingNode: null, // 正在重命名的节点
				dialogVisible2: false,
				editable: 0, //重命名状态
				filterText: "",
				filterText2: "",
				checked: false,
				selectedNodes: [],
				defaultCheckedKeys: [],
				showData: [],
				multipleSelection: [], //表格选中数据
				allPapersData: [],
                filterPapersData:[],
				selectedIds: [],
				address: '',
				treeData: [],
				defaultProps: {
					children: "children",
					label: "name",
				},
				selectedItems: [], // 用于存储选中的题目索引
				isAllSelected: false, // 是否全选
				tabsLsit: [],
				formData: {},
				collectionTestAllId: -1,
				coilingId:0,
				checkedCollectionContentList: [],
				checkedCollectionProgresslist:[],
				testContentId:0,
				testContentDirection: false,
                progressItemId:0,
                progressDirection: false,
                fromScj: 0, //0为从
                options:['上一大题','上一小题', '下一大题', '下一小题', '跳过', '我的回答', '重新回答', '提交'],
                textareaRows : {
                  firstLevel: 1,
                  secondLevel: 1,
                  againLevel: 2,
                  hearing: 3,
                  subject: 1,
                  option: 1,
                  answer: 1,
                  field: 1,
                  icon: 1,
                  topic: 3,
                  keywords: 3,
                  keypoint: 3,
                  refanswer: 3
                },
                fieldsOptions : [
                  {
                    id: 1,
                    name: 'firstLevel',
                    value: "一级题干",
                    label: "一级题干",
                },
                {
                    id: 2,
                    name: 'secondLevel',
                    value: "二级题干",
                    label: "二级题干",
                },
                {
                    id: 3,
                    name: 'againLevel',
                    value: "三级题干",
                    label: "三级题干",
                },
                {
                    id: 4,
                    name: 'audio',
                    value: "材料音频",
                    label: "材料音频",
                },
                {
                    id: 13,
                    name: 'hearing',
                    value: "听力材料",
                    label: "听力材料",
                },
                {
                    id: 5,
                    name: 'subject',
                    value: "题目",
                    label: "题目",
                },
                {
                    id: 6,
                    name: 'option',
                    value: "选项",
                    label: "选项",
                },
                {
                    id: 7,
                    name: 'answer',
                    value: "答案",
                    label: "答案",
                },
                {
                    id: 9,
                    name: 'chart',
                    value: "图表",
                    label: "图表",
                },
                {
                    id: 10,
                    name: 'topic',
                    value: "topic",
                    label: "topic",
                },
                {
                    id: 11,
                    name: 'keywords',
                    value: "keywords",
                    label: "keywords",
                },
                {
                    id: 12,
                    name: 'keypoint',
                    value: "keypoint",
                    label: "keypoint",
                },
                {
                    id: 14,
                    name: 'number_replace',
                    value: "number_replace",
                    label: "number_replace",
                },
                {
                    id: 8,
                    name: 'field',
                    value: "栏位名称",
                    label: "栏位名称",
                },
            ],
            answerMethodMap: answerMethodMap,
            queTypeMap: queTypeMap,
            // queTypeMap: [
            //     {
            //         value: 'readWord',
            //         label: '读单词'
            //     },
            //     {
            //         value: 'readSentences',
            //         label: '读句子'
            //     },
            //     {
            //         value: 'readWordArticle',
            //         label: '读文章'
            //     },
            //     {
            //         value: 'choice',
            //         label: '选择题'
            //     },
            //     {
            //         value: 'situationalResponse',
            //         label: '情景反应'
            //     },
            //     {
            //         value: 'informationParaphrasing',
            //         label: '信息转述'
            //     },
            //     {
            //         value: 'recordAfterListen',
            //         label: '听后记录'
            //     },
            //     {
            //         value: 'dialogue',
            //         label: '对话'
            //       }
            //     ],
                timePath: require("@/assets/images/icon-timer-init.png"),
                timeDisabled: false,
                uploadAudioUrl: uploadAudio,
				display: true,
                displayVisible: true,
                inputVisible: true,
                optionVisible: true,
                isPractise: true,
                optionNotEmpty:true,
                progressItemsSingle:[],
                progressItemsAll:[],
                from: 'special',
                testLevelTreeData:[],
                nodeEdit: false,
                treeNodeRenaming: false,
                screenLeft: 0, // 操作弹框左侧距离
                screenTop: 0, // 操作弹框top侧距离
                scroll: { x: 0, y: 0 },
                lastScroll: { x: 0, y: 0 },
                optTestLevel: 0,
                childLevel: 0,
                showLevelArr: [],
                optTestLevelId: 0,
                optTextLevelLabel:'',
                optType:'',
                testLevelProps: {
                    label: "name",
                    children: "children"
                },
                moduleSelectData: [],
                moduleData: [
                    {
                        value: "对点练",
                        label: "对点练",
                        children:[
                            {
                                value: "听后选择",
                                label: "听后选择",
                            },
                            {
                                value: "听后回答",
                                label: "听后回答",
                            },
                            {
                                value: "听后转述",
                                label: "听后转述",
                            }
                        ]
                    },
                    {
                        value: "专项练",
                        label: "专项练",
                        children:[
                            {
                                value: "听后选择",
                                label: "听后选择",
                            },
                            {
                                value: "听后回答",
                                label: "听后回答",
                            },
                            {
                                value: "听后转述",
                                label: "听后转述",
                            }
                        ]
                    },
                    {
                        value: "新考法",
                        label: "新考法",
                        children:[
                            {
                                value: "新考点",
                                label: "新考点",
                            },
                            {
                                value: "新形势",
                                label: "新形势",
                            },
                            {
                                value: "新题型",
                                label: "新题型",
                            }
                        ]
                    },
                ],
                isEmpty: true,
                topLevel: 0,
                isShowLevelMenu: false,
                editorOption: {readOnly: true},
                treeNodeNum: '', //用于记录当前树节点的id
                contentChangeId: [], // 未保持
			};
		},
		created() {
            this.$store.state.pageNum = "2";  //设置当前页面编号为2，听说精练模块
            //拿取题源对应模块的数据
            let questionSource = this.$route.query.questionSource;
            let moduleSeletctData = this.moduleData.filter(item => {return item.value == questionSource});
            if(moduleSeletctData.length){
                this.moduleSeletctData = moduleSeletctData[0].children;
            }
		},
		watch: {
			checked(val) {
				if (val) {
					this.selectAll();
				} else {
					this.cancelSelectAll();
				}
			},
			coilingId(val) {
				console.log('套卷id发生变化，最新值是:', val)
			},
			
		},
		methods: {
            // 未存储-保存id
            contentChangeIdUn(id) {
                if (!this.contentChangeId.includes(id)) {
                    this.contentChangeId.push(id);
                    sessionStorage.setItem(
                    "contentChangeId",
                    JSON.stringify(this.contentChangeId)
                    );
                }
            },
            // 存储-删除id
            contentChangeIdEnd(id) {
                if (this.contentChangeId.includes(id)) {
                    this.contentChangeId.splice(
                    this.contentChangeId.findIndex((x) => x == id),
                    1
                    );
                    sessionStorage.setItem(
                        "contentChangeId",
                        JSON.stringify(this.contentChangeId)
                    );
                }
            },
            afterToggle(){

            },
            renderContent2(h, { node,data }) {  //newtodo
                return (
                    <span class="custom-tree-node">
                        <span>{node.label}---</span>
                        <span>
                        <el-button size="mini" type="text" on-click={ () => this.append(data) }>Append</el-button>
                        <el-button size="mini" type="text" on-click={ () => this.remove(node, data) }>Delete</el-button>
                        </span>
                    </span>
                );
            },
            updateModule(moduleName){   //新增修改模块名称
                let data = {
                    "id": this.catalogId||'', // 无则新增，有则修改
                    "bookId": this.bookId,
                    "name": moduleName
                }
                console.log(data);
                updateModuleInfo(data)
                .then((res) => {
                    if (res["code"] == 0) {
                        let moduleData = res["data"]
                        this.catalogId = moduleData.id
                        EventBus.$emit("getcatalogIdChange",this.catalogId)
                    }else{
                        this.$message.error(res.info);
                    }
                    console.log(res,this.catalogId);
                })
                .catch((err) => {
                    console.log("updateModuleInfo err", err);
                });
            },
			getCollectionStatus(coid) {
                let key = coid + "";
                let content = sessionStorage.getItem(key);
				let data = {
					collectionType: "test_all",
					area: this.$route.query.region,
					year: this.$route.query.year,
					source: this.$route.query.questionSource,
                    content: content,
					coilingId: coid
				};
				console.log('getCollectionStatus_data====', data);
				getCollectionStatus(data)
					.then((res) => {
						this.collectionTestAllId = res["data"];
						console.log('this.collectionTestAllI===', this.collectionTestAllId)
					})
					.catch((err) => {
						console.log("getCollectionStatus err", err);
					});
			},
			// 获取套卷
			getCoiling(callBack) {
                console.log("sdfessergxgvxv",this.$refs.addressFilterRef.form)
            let type = ['题型专项训练']
            //let type = this.$refs.addressFilterRef.form.type;
            let module = this.$refs.addressFilterRef.form.type//module;

            type.push(module)
            console.log("module====" + module)
            // let catalogType = type.join(",");

            let data = {
                bookId: this.bookId,
                // catalogType,
                catalogId: this.catalogId
            };
            console.log(TAG + "getCoiling", data);

            getAllCoiling(data)
                .then((res) => {
                    console.log(TAG + "getAllCoiling res", res);
                    if (res["code"] == 0) {
                        //let DESCCoilingList = res["data"].sort((a, b) => a.id - b.id);
                        let DESCCoilingList = res["data"]

                        this.$refs.addCoilingRef.coilingList = DESCCoilingList;
                        console.log('DESCCoilingList的id===', DESCCoilingList[0]['id']);
                        callBack();
                        // this.coilingId = DESCCoilingList[0]['id'];  //此处把接口返回的list表中第一个数据中的id给了coilingId，fourUpdate
                        //this.$refs.testContentRef.nowId = DESCCoilingList[0]['id'];
                    }
                })
                .catch((err) => {
                    console.log(TAG + "getAllCoiling err", err);
                });
        },

        // 新增套卷
        addCoilingHandle(callFn) {
            console.log('新collingId===', callFn);
            let formType = this.$refs.addressFilterRef.form.type;
            let name = getModuleType(formType,this)==1 ? "套卷" : "Group";//formType == "听说模拟训练" ? "套卷" : "Group";
            const paperCounts = _.map(this.$refs.addCoilingRef.coilingList, p => {
                return Number(_.get(p, 'name', '').replace(name, ''))
            })
            const newCout = paperCounts.length > 0 ? _.max(paperCounts) + 1 : 1;
            // let length = this.$refs.addCoilingRef.coilingList.length + 1;

            let catalogType = "";
            let subType = "";

            if (typeof formType == "string") {
                catalogType = formType;
            } else if (formType instanceof Array) {
                catalogType = formType[0];
                subType = formType[1];
            }

            console.log(88852, catalogType);
            if (!catalogType) return;

            let data = {
                bookId: this.bookId,
                catalogType,
                subType,
                name: name + newCout,
            };
            console.log(TAG, "addCoilingHandle", data, JSON.stringify(formType));

            addRefiningCoiling(data)
                .then((res) => {
                    if (res["code"] == 0) {
                        console.log(TAG, "addCoilingHandle res", res);

                        // 获取套卷
                        this.getCoiling();

                        callFn && callFn(res["data"]["id"]);
                    } else {
                        this.$message.error("新增套卷失败！");
                    }
                })
                .catch((err) => {
                    console.log(TAG, "addCoilingHandle err", err);
                    this.$message.error("新增套卷失败！");
                });
        },

        fieldsArrChange(arr) {
            this.lanweiList = arr;
            console.log("栏位列表变化", arr);
            let time = parseInt(new Date().getTime() / 1000) + "";
            let questionNumberCopy = [];

            for (let i = 0; i < arr.length; i++) {
                time++;

                if (arr[i]["type"] == "一级题干") {
                    questionNumberCopy.push({
                        id: time,
                        divId: arr[i]["id"],
                        label: "一",
                        name: arr[i]["type"],
                    });
                } else if (arr[i]["type"] == "二级题干") {
                    if (!questionNumberCopy.length) {
                        return;
                    }

                    let questionOne = questionNumberCopy[questionNumberCopy.length - 1];
                    if (!("children" in questionOne)) {
                        questionOne.children = [];
                    }
                    questionOne.children.push({
                        id: time,
                        divId: arr[i]["id"],
                        label: "①",
                        name: arr[i]["type"],
                    });
                } else if (arr[i]["type"] == "题目") {
                    if (questionNumberCopy.length) {
                        let questionLast =
                            questionNumberCopy[questionNumberCopy.length - 1];

                        if ("children" in questionLast) {
                            if (questionLast.children.length) {
                                let questionLastLast =
                                    questionLast.children[questionLast.children.length - 1];

                                if (questionLastLast.name == "题目") {
                                    questionLast.children.push({
                                        id: time,
                                        divId: arr[i]["id"],
                                        label: "4",
                                        name: arr[i]["type"],
                                    });
                                } else {
                                    if ("children" in questionLastLast) {
                                        questionLastLast.children.push({
                                            id: time,
                                            divId: arr[i]["id"],
                                            label: "1",
                                            name: arr[i]["type"],
                                        });
                                    } else {
                                        questionLastLast.children = [{
                                            id: time,
                                            divId: arr[i]["id"],
                                            label: "2",
                                            name: arr[i]["type"],
                                        },];
                                    }
                                }
                            } else {
                                questionLast.children.push({
                                    id: time,
                                    divId: arr[i]["id"],
                                    label: "3",
                                    name: arr[i]["type"],
                                });
                            }
                        } else {
                            questionLast.children = [{
                                id: time,
                                divId: arr[i]["id"],
                                label: "4",
                                name: arr[i]["type"],
                            },];
                        }
                    } else {
                        questionNumberCopy.push({
                            id: time,
                            divId: arr[i]["id"],
                            label: "5",
                            name: arr[i]["type"],
                        });
                    }
                } else {
                    console.log(123);
                }
            }

				console.log("questionNumberCopy", questionNumberCopy);
				this.questionNumber = questionNumberCopy;
			},
			/* eslint-disable */
			//收藏夹显示
			favoritesShow() {
                this.fromScj = 1
				this.tabsShow = true;
				this.tabsLsit = [{
						name: "试题单个栏位",
						type: "test_single",
						message: {
							pos: 1,
						},
					},
					{
						name: "试题整个栏位",
						type: "test_all",
						message: {
							pos: 2,
						},
					},
					{
						name: "答题单个流程",
						type: "answer_single",
						message: {
							pos: 3,
						},
					},
					{
						name: "答题整个流程",
						type: "answer_all",
						message: {
							pos: 4,
						},
					},
				];
				this.checkedCollectionContentList = []
                this.checkedCollectionProgresslist = []
                this.testContentId = 0;
                this.testContentDirection = false;
                this.progressItemId = 0;
                this.progressDirection = false;
                this.selectedIds = []
                this.selectedNodes = []
				this.getStarList('test_single');
                this.dialogVisible = true;
			},
            scjClose() {
                this.defaultCheckedKeys  = []
                this.activeName = "test_single"
                this.fromScj = 0
                this.filterText = ''
            },
            closeSelectPaper(){
                this.filterText2 = ''
            },
			//收藏夹获取列表数据
			getStarList(type) {
				console.log('address===', this.address)
				getCollectList(this.address, type)
					.then((res) => {
						this.treeData = res.data.sort(this.sortByYear);
                        this.treeData = res.data
                        let checkedAll = true;
                        this.treeData.forEach((item)=>{
                            if (item.children.length > 0) {
                                item.children.forEach((child) => {
                                    if (!this.selectedIds.includes(child.id)) {
                                        checkedAll = false
                                        return;
                                    }
                                })
                            } else {
                                if (!this.selectedIds.includes(item.id)) {
                                    checkedAll = false
                                    return;
                                }
                            }
                        })
                        if (this.treeData.length === 0) {
                            checkedAll = false;
                        }
                        this.checked = checkedAll
					})
					.catch((err) => {
						console.log("getCollectList err", err);
					});
			},
			getForm(form) {
				this.address = form.address
				this.formData = form
			},
			// 排序函数
			sortByYear(a, b) {
				return parseInt(b.year) - parseInt(a.year);
			},
			//重命名
			handleNodeClick(data) {
				// 切换节点的编辑状态
				console.log(data);
				this.editable = data.id;
			},
			handleRename(node, data) {
				this.isRenaming = true;
				this.newName = data.name; // 初始化为当前节点名称
				this.selectId = data.id;
				this.renamingNode = node; // 保存正在重命名的节点
			},
			scjShow(data) {
                console.log("打开收藏夹",this.$refs.tree)
                // this.$refs.tree.setCheckedKeys([]);
                if (this.$refs.tree) {
                    this.$refs.tree.setCheckedKeys([]);
                }
                this.selectedIds = []
                this.defaultCheckedKeys = []
                this.checkedCollectionContentList = []
                this.checkedCollectionProgresslist = []
                this.selectedNodes = []
                this.filterText = ''
                this.filterText2 = ''
				this.tabsShow = data.n2;
                this.activeName = "test_single"
				if (data.from == "content") {
                    this.fromScj = 0
					this.testContentId = data.nowId
					this.testContentDirection = data.direction
                    
                    this.handleChildValue()
				} else if (data.from == "progress") {
                    this.fromScj = 0
                    this.progressItemId = data.nowId
                    this.progressDirection = data.direction
                    
                    this.handleDataFromGrandchild()
				}
                this.dialogVisible = true;
                //this.$refs.tree.setCheckedKeys([]);
			},
			finishRename() {
				reName(this.selectId, this.newName)
					.then((res) => {
						if (res["code"] == 0) {
							if (this.newName && this.newName !== this.renamingNode.data.name) {
								// 更新节点数据
								this.renamingNode.data.name = this.newName;
								this.isRenaming = false;
								this.newName = "";
								this.renamingNode = null;
							} else {
								this.isRenaming = false;
								this.newName = "";
								this.renamingNode = null;
							}
							this.$message.success("修改成功！");
						}
					})
					.catch((err) => {
						console.log(TAG, "addCoilingHandle err", err);
						this.$message.error("修改失败！");
					});
			},
			//tab切换
			handleClick(tab, event) {
				console.log(tab.index, event, this.activeName);
                this.checked = false
                this.defaultCheckedKeys = this.selectedIds
				this.getStarList(this.activeName);
			},
			//收藏夹搜索
			handleSearch() {
				this.$refs.tree.filter(this.filterText);
			},
			//搜索框过滤
			filterNode(value, data) {
				if (!value) return true;
				return data.name.indexOf(value) !== -1;
			},
			//单栏搜索
			handleSearch2() {
				this.filterPapersData = this.allPapersData.filter((item) => {
                    let name = item.paperName + "-" + item.type + "-" + item.year
					return name.toLowerCase().includes(this.filterText2.toLowerCase());
				});
			},
			handleCheckChange(data, checked) {
                if ((this.activeName == "test_single" || this.activeName == "answer_single")  && data.pid === 0) {
                    return;
                }
                //console.log("data===", data)
                console.log("data.id===", data.id)
                if (checked) {
                    this.selectedIds.push(data.id)
                    this.selectedNodes.push(data);
                } else {
                    this.selectedIds = this.selectedIds.filter(item=> item != data.id);
                    const index = this.selectedNodes.findIndex(
                    	(node) => node.id === data.id
                    );
                    if (index !== -1) {
                    	this.selectedNodes.splice(index, 1);
                    }
                }
                console.log("selectedIds===", this.selectedIds)
                console.log("activeName===", this.activeName)
                if (this.activeName == "test_single") {
                    let contentObj = JSON.parse(data.content)                 
                    if (checked) {
                        this.checkedCollectionContentList.push(contentObj);			
                    } else {
                        this.checkedCollectionContentList = this.removeOnce(this.checkedCollectionContentList, JSON.parse(data.content));
                    }          
                } else if (this.activeName == "test_all") {
                    let contentArr = JSON.parse(data.content)
                    if (checked) {            
                        contentArr.forEach((content,index) => {
                            this.checkedCollectionContentList.push(content);
                        })
                    } else {
                        contentArr.forEach((content,index) => {
                            this.checkedCollectionContentList = this.removeOnce(this.checkedCollectionContentList, content);
                        })
                    }
                    console.log(this.activeName + " checkedCollectionContentList:" + this.checkedCollectionContentList)
                } else if (this.activeName == "answer_single") {
                    let progressObj = JSON.parse(data.progress)
                    if (checked) {
                        this.checkedCollectionProgresslist.push(progressObj);
                        this.progressItemsSingle.push(progressObj)
                    } else {
                        this.checkedCollectionProgresslist = this.removeOnce(this.checkedCollectionProgresslist, JSON.parse(data.progress));
                        this.progressItemsSingle = this.removeOnce(this.progressItemsSingle, JSON.parse(data.progress));
                    }
                } else if (this.activeName == "answer_all") {
                    let progressArr = JSON.parse(data.progress)
                    console.log('progressItems==', progressArr.length)
                    
                    if (checked) {
                        console.log("checked")
                        this.progressItemsAll.push(progressArr);
                        progressArr.forEach((progress) => {
                            progress.progressItems.forEach((progressItem) => {                          
                                this.checkedCollectionProgresslist.push(progressItem);
                            })
                        })
                    } else {
                        console.log("not checked")
                        this.progressItemsAll = this.removeOnce(this.progressItemsAll, JSON.parse(data.progress));
                        progressArr.forEach((progress) => {
                            progress.progressItems.forEach((progressItem) => {
                                this.checkedCollectionProgresslist = this.removeOnce(this.checkedCollectionProgresslist, progressItem);
                            })
                        })
                        
                    }
                    console.log(this.activeName + " checkedCollectionProgresslist:" + this.checkedCollectionProgresslist)
                }
			},
            removeOnce(arr, item) {
                let index  = -1
                arr.forEach((i, ind) => {
                    if  (i.id === item.id) {
                        if (i.typeId) {
                            if (i.typeId === item.typeId) {
                                index = ind;
                            }      
                        } else {
                            index = ind;
                        }      
                    }
                })
                if (index !== -1) {
                    arr.splice(index, 1);
                }
                return arr;
            },
			//确认删除
			handleConfirm() {
				deleteStar(this.selectedIds).then((res) => {
					if (res["code"] == 0) {
						this.$message({
							message: "删除成功",
							type: "success",
						});
						this.treeData = this.removeSelectedNodesFromTree(
							this.treeData,
							this.selectedNodes
						);
						this.selectedNodes = []; // 清空选中的节点数组
                        this.checkedCollectionContentList = [];
                        this.checkedCollectionProgresslist = [];
                        this.selectedIds = []
					} else {
						this.$message.error("删除失败");
					}
				});
			},
			handleCancel() {
				this.$message({
					message: "已取消删除",
					type: "info",
				});
			},
			removeSelected() {
				if (this.selectedNodes.length > 0) {
					//调出确认框
                    this.$confirm(`是否删除选中的收藏吗?`, "删除提示", {
                      distinguishCancelAndClose: true,
                      confirmButtonText: "删除",
                      cancelButtonText: "取消",
                      customClass: "customClass",
                      confirmButtonClass: "btnConfirm",
                      cancelButtonClass: "btnCancel",
                    })
                      .then(() => {
                        this.handleConfirm()
                      })
                      .catch(() => {})
				} else {
					this.$message.warning("请先选中要删除的节点");
				}
			},
			//删除节点
			removeSelectedNodesFromTree(nodes, selectedNodes) {
                this.getStarList(this.activeName)
			},
			//全选
			selectAll() {
				// 获取所有节点的keys
				this.defaultCheckedKeys = this.getAllNodeKeys(this.treeData);
				//this.updateDefaultCheckedKeys();
			},
			getAllNodeKeys(data) {
				const keys = [];
				const traverse = (nodes) => {
					nodes.forEach((node) => {
						keys.push(node.id);
						if (node.children && node.children.length > 0) {
							traverse(node.children);
						}
					});
				};
				traverse(data);
				return keys;
			},
			updateDefaultCheckedKeys() {
				this.defaultCheckedKeys = [...this.selectedNodes];
			},
			//取消全选
			cancelSelectAll() {
				this.$refs.tree.setCheckedNodes([]);
				this.selectedNodes = [];
			},
			//表格选择
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			//插入
			insertList() {
                //this.dialogVisible = false;
                if (this.fromScj === 0) {
                    this.showData = [];
                    console.log('选中收藏的数据有几条', this.checkedCollectionContentList.length)
                    if (this.checkedCollectionContentList.length > 0) {
                        if (!this.testContentDirection && this.testContentId > 0) {
                            this.checkedCollectionContentList.reverse();
                        }
                        this.checkedCollectionContentList.forEach((e) => {
                        	this.$refs.testContentRef.operateInsertCollection(this.testContentDirection, this.testContentId, e)
                        });
                        this.$message({
                          message: "添加收藏栏位成功！",
                          type: "success",
                        });
                    }
                    if (this.checkedCollectionProgresslist.length > 0) {
                        if (!this.progressDirection && this.progressItemId > 0) {
                            this.checkedCollectionProgresslist.reverse();
                        }
                        this.checkedCollectionProgresslist.forEach((e) => {
                        	this.$refs.answeringProcessRef.operateInsertProgressCollection(this.progressDirection, this.progressItemId, e)
                        });
                        this.$message({
                          message: "添加收藏流程成功！",
                          type: "success",
                        });
                    }
                    this.$refs.answeringProcessRef.showTopicData();  
                    this.dialogVisible = false;
                    this.selectedIds = []
                    this.checkedCollectionContentList = []
                    this.checkedCollectionProgresslist = []

                    //修改在创建流程里面收藏流程进行插入流程，和收藏夹插入保持一致
                    let idArr = [];
                    idArr.push(this.coilingId)
                    // EventBus.$emit("insert2paperStorage", this.selectedNodes, idArr);   
                    // if(this.progressItemId==''){
                    //     EventBus.$emit("insert2paperStorage", this.selectedNodes, idArr);  
                    // }
                    EventBus.$emit("contentChangeIdUn", this.$store.state.coilingId);   //给试卷添加未保存的星号
                    this.$nextTick(()=>{    //更新显示里面已失效的状态
                        EventBus.$emit('updateProgressItem',{'newVal':this.$store.state.fieldsJSON})
                    })
                } else {
                    if (this.selectedIds.length === 0) {
                        this.$message.error("您还没有选择收藏！");
                        return;
                    }
                    getPapersByRegion(this.$route.query.regionId).then((res) => {
                    	if (res["code"] == 0) {
                    		this.filterPapersData = this.allPapersData = res["data"]
                    	}
                    });
                    console.log("selectedNodes9999=", this.selectedNodes)
                    //this.checked = false;
                    this.activeName = "test_single"
                    this.dialogVisible = false
                    this.dialogVisible2 = true
                }        
			},
			//收藏试题显示
			handleChildValue() {
				this.dialogVisible = true;
				this.tabsShow = true;
				this.tabsLsit = [{
						name: "试题单个栏位",
						type: "test_single"
					},
					{
						name: "试题整个栏位",
						type: "test_all"
					},
				];
                this.checkedCollectionContentList = []
                this.checkedCollectionProgresslist = []
                this.selectedIds = []
                this.activeName = "test_single"
				this.getStarList('test_single');
			},
			//收藏流程显示
			handleDataFromGrandchild() {
				this.dialogVisible = true;
				this.tabsShow = true;
				this.tabsLsit = [{
						name: "答题单个流程",
						type: "answer_single"
					},
					{
						name: "答题整个流程",
						type: "answer_all"
					},
				];
                this.checkedCollectionContentList = []
                this.checkedCollectionProgresslist = []
                this.selectedIds = []
                this.activeName = "answer_single"
				this.getStarList('answer_single');
			},
            insertCollections2Papers() {
                if (this.multipleSelection.length === 0) {
                    this.$message.error("您还没有选择需要插入收藏的套卷！");
                    return;
                }
                let collectionIdsStr = this.selectedIds.join(",")
                console.log("collectionIds===", collectionIdsStr)
                let checkedPaperIdsArr = []
                this.multipleSelection.forEach((item)=>{
                    checkedPaperIdsArr.push(item.id)
                })
                EventBus.$emit("insert2paperStorage", this.selectedNodes, checkedPaperIdsArr);
                this.$message.success("插入成功！");
                this.dialogVisible2 = false          
            },
            getqueTypeMapLabel(val) {
                if (val === '') {
                    return "请选择"
                }
                let res = ''
                this.queTypeMap.forEach((item) => {
                    if (item.value === val) {
                        res = item.label;
                    }
                })
                return res;
            },
            getAnswerMethodLabel(val){
              if(!val)return '请选择'
              const res = this.answerMethodMap.find(item=>item.value === val)
              return res?.label || ''
            },
            //转换成'00:00'分秒显示
            parseTime(scecond) {
              let secondTime = scecond
              let minuteTime = 0;
              if (scecond > 60) {
                minuteTime = parseInt(secondTime / 60);
                secondTime = parseInt(secondTime % 60);
              }
              secondTime = secondTime < 10 ? "0" + secondTime : secondTime;
              let result = "" + secondTime + "";
              if (minuteTime > 0) {
                //若分钟数是个位数，前面用0补齐
                minuteTime = minuteTime < 10 ? "0" + minuteTime : minuteTime;
                result = "" + minuteTime + ":" + result;
              } else {
                //若分钟数为0，用"00"表示
                result = "" + "00" + ":" + result;
              }
              return result;
            },
            renderContent(h, { node, data, store }) {
              return (
                  <span class="custom-tree-node">
                      <span dblclick="this.nodeEdit = !this.nodeEdit" v-if="!nodeEdit">{node.label}</span>
                      <span v-if="nodeEdit">
                          <el-input v-modle="node.lebel"></el-input>
                      </span>
                  </span>
              );
            },
            getTreeNodeColor(level) {
                switch(level) {
                    case 1:
                        return "pink";
                    case 2:
                        return "blue";
                    case 3:
                        return "yellow";
                    case 4:
                        return "black";
                    default:
                        return "red";
                }
            },
            editNode(treeNodeId) {
                let node = document.getElementById(treeNodeId)
                let parentNode = node.parentElement
                parentNode.removeChild(node)
                let editHtml = document.createElement("input")
                editHtml.value = treeNodeId;
                //let editHtml = "<input value='" + treeNodeId + "'/>";
                parentNode.append(editHtml)
            },
            getTreeNodeFocus(data){
                this.$nextTick(() => {
                    this.$refs[data.id] && this.$refs[data.id].focus() // 获取输入框，自动获取焦点
                })
            },
            headerDbClick(data) {
                if(data.id==-1){
                    this.$nextTick(() => {
                        this.$refs[data.id] && this.$refs[data.id].focus() // 获取输入框，自动获取焦点
                    })
                    return;
                }
                this.isOperate=false

                this.isShowLevelMenu=false;
                console.log('双击节点', data)
                // if (!this.treeNodeRenaming) {
                    this.showLevelArr = [];
                    if(data.children){
                        if(data.children.length>0){
                            // this.childLevel = data.children[0].lvl;
                            this.showLevelArr.push(data.children[0].lvl);
                        }else{
                            // this.childLevel = data.lvl+1
                            for(let i=data.lvl+1;i<=4;i++){
                                this.showLevelArr.push(i);
                            }
                        }
                    }else{
                        this.childLevel = data.lvl+1
                        for(let i=data.lvl+1;i<=4;i++){
                            this.showLevelArr.push(i);
                        }
                    }
                    this.showLevelArr.push(data.lvl);

                    this.$set(data, 'isEdit', true)
                    this.treeNodeRenaming = true;
                    this.optTestLevel = data.lvl
                    this.optTestLevelId = data.id
                    this.optTextLevelLabel = data.name
                    console.log("optTestLevel11111111=====", this.optTestLevel);
                    console.log("optTestLevelId22222222", this.optTestLevelId);
                    this.optType = 'rename'
                    this.$nextTick(() => {
                        this.$refs[data.id] && this.$refs[data.id].focus() // 获取输入框，自动获取焦点
                    })
                // }
                
            },
            setNodeName(val,callBack){
                callBack(val);
            },
            handleInputBlur(event, data, node) {
                console.log(event.target.value)
                const inputValue = event.target.value.trim()?event.target.value.trim():"请输入层级名称"
                // if (inputValue === '') {
                //     this.$message({
                //         type: 'warning',
                //         message: '节点名称不能为空,请重新输入'
                //     })
                //     this.$refs[data.id].focus()
                // } else 
                if (inputValue === this.optTextLevelLabel) {
                    this.$set(data, 'isEdit', false)
                    this.treeNodeRenaming = false
                    this.nodeEdit = false
                } else {
                    this.$set(data, 'isEdit', false);
                    data.name = inputValue  //将新的名称赋值给tree节点
                    this.treeNodeRenaming = false
                    this.nodeEdit = false
                    let pid = 0
                    if (node.parentId) { 
                        pid = node.parentId
                    }
                    let children = node.parendChilds;
                    let previousId = -1
                    for (let child of children) {
                        if (child.id === node.id) {
                            break;
                        } else {
                            previousId = child.id
                        }
                    }
                    console.log('previousId====', previousId,this.optType)
                    // 调用后台根据id修改名称
                    if (this.optType === 'addNew') {
                        const addParams = {
                            "bookCatalogId" : this.catalogId,//this.$route.query.catalogId,
                            "lvl" : data.lvl,
                            "pid": pid,
                            "name": data.name,
                            "previousId": previousId
                        }
                        addTestLevel(addParams)
                            .then((res) => {
                                if (res["code"] == 0) {
                                    //更新该新增节点数据
                                    // let pNode = this.$refs.testLevelTreeRef.getNode(pid);
                                    //非根节点
                                    // if (pNode) {
                                    //     let childrenData  = pNode.data.children
                                    //     for (let child of childrenData) {
                                    //         if (child.isAdd) {
                                    //             let childNode = this.$refs.testLevelTreeRef.getNode(child);
                                    //             console.log('childNode11111', childNode)
                                    //             this.$set(childNode, 'id', res["data"])
                                    //             child.isAdd = false
                                    //             child.id = res["data"]
                                    //             break;
                                    //         }
                                    //     }
                                    // } else {
                                    //     //TODO 根节点
                                    // }
                                    // this.$refs.testLevelTreeRef.updatePartTree(res["data"]);
                                    this.getTestLevelTree()
                                    this.$message.success("新增试题层级成功！");
                                    this.topLevel=data.lvl
                                } else {
                                    // this.$refs.testLevelTreeRef.updatePartTree(res["data"]);
                                    this.getTestLevelTree();//重新刷新树结构
                                    this.$message.error("新增试题层级失败！");
                                }
                            })
                            .catch((err) => {
                                console.log(err)
                                this.getTestLevelTree();//重新刷新树结构
                                this.$message.error("新增试题层级失败！");
                            });
                    } else if(this.optType === 'rename') {
                        let renameParams = {
                            "id" : data.id==-1?'':data.id,
                            "name": data.name
                        }
                        renameTestLevel(renameParams)
                            .then((res) => {
                                this.$message.success("试题层级重命名成功！");
                            })
                            .catch((err) => {
                                this.$message.error("试题层级重命名失败！");
                            });
                    }
                    
                }
                //this.currentName = ''
            },
            // handleInputBlur(event, data, node) {
            //     console.log(event.target.value)
            //     const inputValue = event.target.value.trim()
            //     if (inputValue === '') {
            //         this.$message({
            //             type: 'warning',
            //             message: '节点名称不能为空,请重新输入'
            //         })
            //         this.$refs[data.id].focus()
            //     } else if (inputValue === this.optTextLevelLabel) {
            //         this.$set(data, 'isEdit', false)
            //         this.treeNodeRenaming = false
            //         this.nodeEdit = false
            //     } else {
            //         this.$set(data, 'isEdit', false)
            //         data.name = inputValue
            //         this.treeNodeRenaming = false
            //         this.nodeEdit = false
            //         let pid = 0
            //         if (node.parent.data.id) { 
            //             pid = node.parent.data.id
            //         }
            //         let children = node.parent.childNodes;
            //         let previousId = -1
            //         for (let child of children) {
            //             if (child.id === node.id) {
            //                 break;
            //             } else {
            //                 previousId = child.data.id
            //             }
            //         }
            //         console.log('previousId====', previousId)
            //         // 调用后台根据id修改名称
            //         if (this.optType === 'addNew') {
            //             const addParams = {
            //                 "bookCatalogId" : this.$route.query.catalogId,
            //                 "lvl" : data.lvl,
            //                 "pid": pid,
            //                 "name": data.name,
            //                 "previousId": previousId
            //             }
            //             addTestLevel(addParams)
            //                 .then((res) => {
            //                     if (res["code"] == 0) {
            //                         //更新该新增节点数据
            //                         let pNode = this.$refs.testLevelTreeRef.getNode(pid);
            //                         //非根节点
            //                         if (pNode) {
            //                             let childrenData  = pNode.data.children
            //                             for (let child of childrenData) {
            //                                 if (child.isAdd) {
            //                                     let childNode = this.$refs.testLevelTreeRef.getNode(child);
            //                                     console.log('childNode11111', childNode)
            //                                     this.$set(childNode, 'id', res["data"])
            //                                     child.isAdd = false
            //                                     child.id = res["data"]
            //                                     break;
            //                                 }
            //                             }
            //                         } else {
            //                             //TODO 根节点
            //                         }
                                    
            //                         this.getTestLevelTree()
            //                         this.$message.success("新增试题层级成功！");
            //                     } else {
            //                         this.getTestLevelTree();//重新刷新树结构
            //                         this.$message.error("新增试题层级失败！");
            //                     }
            //                 })
            //                 .catch((err) => {
            //                     console.log(err)
            //                     this.getTestLevelTree();//重新刷新树结构
            //                     this.$message.error("新增试题层级失败22222！");
            //                 });
            //         } else if(this.optType === 'rename') {
            //             let renameParams = {
            //                 "id" : data.id,
            //                 "name": data.name
            //             }
            //             renameTestLevel(renameParams)
            //                 .then((res) => {
            //                     this.$message.success("试题层级重命名成功！");
            //                 })
            //                 .catch((err) => {
            //                     this.$message.error("试题层级重命名失败！");
            //                 });
            //         }
                    
            //     }
            //     //this.currentName = ''
            // },
            handleEnter(event, data, node) {
                // this.isShowLevelMenu=false;
                if (event.key === 'Enter') { // 检查按下的是否是回车键
                    // 调用你想要执行的函数
                     event.target.blur()
                }
            },
            treeInputBlur(event, data, node) {
                this.isShowLevelMenu=false;
                this.handleInputBlur(event, data, node);
                this.isOperate = false;
            },
            handleBlur(event, data, node){
                this.isShowLevelMenu=false;
                this.handleInputBlur(event, data, node);
                this.isOperate = false;
            },
            // 点击操作
            handleOperate(e, id, level, label) {
                // console.log(e,id);
            //   this.$refs[id].focus();console.log(this.$refs[id])

              if (this.nodeEdit && id=== -1) {
                 this.$message.error("请先完成添加层级操作！");
                 return;
              }
              console.log("高度", window.innerHeight);
              this.lastScroll = _.cloneDeep(this.scroll);
              let wHeight = window.innerHeight;
               this.isOperate = !this.isOperate;
            
              console.log("isOperate", this.isOperate);
              setTimeout(()=>{
                console.log("isOperate", this.isOperate);
                // this.isOperate = !this.isOperate;
              },2000)
            
              const rect = e.target.getBoundingClientRect();
              console.log('rect', rect)
            
              this.screenLeft = rect.left
              if (rect.top + 150 < wHeight) {
                console.log("rect.top + 150", rect.top + 150);
                this.screenTop = rect.top + window.scrollY + 26;
              } else {
                this.$nextTick(() => {
                  let operateBoxH = this.$refs.operateBox.offsetHeight;
                  console.log("operateBoxH", operateBoxH);
            
                  this.screenTop = rect.top - operateBoxH - 6;
                });
              }
            },
            // 监听点击事件
            monitoringClick(e) {
              const target = e.target;
              const classList = target.classList;
            
              // 转换为字符串输出
              const classes = Array.from(classList).join(" ");
            
              if (classes != "handleFields") {
                //   this.isOperate = false notodo
              }
            },
            handleScroll() {
              this.scroll = {
                x: window.scrollX,
                y: window.scrollY
              }
            },
            insertLevelNode(lvl){
                if(!this.catalogId){
                    this.isShowLevelMenu=false
                    this.$message.error("请先编辑模块！");
                    return;
                }
                this.optType = "addNew";
                this.isShowLevelMenu=false;
                this.nodeEdit = true
                this.optTestLevel = lvl
                // this.optTestLevelId = newId
                this.optTextLevelLabel = ''
                this.$refs.testLevelTreeRef.createLevel({},lvl);
            },
            addLevel1Node() {
                this.isShowLevelMenu = !this.isShowLevelMenu;
                 //调用自定义tree组件方法
                // this.$refs.testLevelTreeRef.createLevel({},0);
                return;


                if(!this.catalogId){
                    this.$message.error("请先编辑模块！");
                    return;
                }
                if (this.nodeEdit) {
                    this.$message.error("请先完成上次编辑！");
                    return;
                }
                let newId = parseInt(new Date().getTime())
                //testLevelTreeRef
                this.testLevelTreeData.unshift(
                    {
                      id: newId,
                      name: '',
                      lvl:1,
                      isEdit: true,
                      isAdd: true,
                      children: [],
                    }
                )
                this.nodeEdit = true
                this.optTestLevel = 1
                this.optTestLevelId = newId
                this.optTextLevelLabel = ''
                this.optType = 'addNew'


               
                
            },
            insertTreeLevelNode(id, direction, level) {
                console.log("id===", id)
                console.log("level===", level,direction)
                // if (this.nodeEdit) {
                //     this.$message.error("请先完成上次编辑！");
                //     return;
                // }
                this.isOperate=false;
                this.optType = 'addNew'
                this.nodeEdit = true
                this.optTestLevel = level
                // this.optTestLevelId = newId
                this.optTextLevelLabel = ''
                if(direction){
                    this.$refs.testLevelTreeRef.insertUpNode();
                }else{
                    this.$refs.testLevelTreeRef.insertDownNode(level);
                }
                // let idNode = this.$refs.testLevelTreeRef.getNode(id);
                // console.log("idNode===", idNode)
                // this.$set(idNode.data, 'isEdit', false)
                // let newId = parseInt(new Date().getTime())
                // let newLevelTreeNodeData = {
                //       id: newId,
                //       name: '',
                //       lvl:level,
                //       isEdit: true,
                //       isAdd: true,
                //       children: [],
                // }
                
                // if (direction) {
                //   // 向上
                //   this.$refs.testLevelTreeRef.insertBefore(newLevelTreeNodeData, idNode)
                // } else {
                //     console.log("idNode.data.level===", idNode,idNode.data.level)
                //     if (idNode.data.lvl != level) {
                //         this.$refs.testLevelTreeRef.append(newLevelTreeNodeData, idNode)
                //     } else {
                //         this.$refs.testLevelTreeRef.insertAfter(newLevelTreeNodeData, idNode)
                //     }
                // }
                
            },
            // insertTreeLevelNode(id, direction, level) {
            //     console.log("id===", id)
            //     console.log("level===", level)
            //     if (this.nodeEdit) {
            //         this.$message.error("请先完成上次编辑！");
            //         return;
            //     }
            //     let idNode = this.$refs.testLevelTreeRef.getNode(id);
            //     console.log("idNode===", idNode)
            //     this.$set(idNode.data, 'isEdit', false)
            //     let newId = parseInt(new Date().getTime())
            //     let newLevelTreeNodeData = {
            //           id: newId,
            //           name: '',
            //           lvl:level,
            //           isEdit: true,
            //           isAdd: true,
            //           children: [],
            //     }
                
            //     if (direction) {
            //       // 向上
            //       this.$refs.testLevelTreeRef.insertBefore(newLevelTreeNodeData, idNode)
            //     } else {
            //         console.log("idNode.data.level===", idNode,idNode.data.level)
            //         if (idNode.data.lvl != level) {
            //             this.$refs.testLevelTreeRef.append(newLevelTreeNodeData, idNode)
            //         } else {
            //             this.$refs.testLevelTreeRef.insertAfter(newLevelTreeNodeData, idNode)
            //         }
            //     }
            //     this.optType = 'addNew'
            //     this.nodeEdit = true
            //     this.optTestLevel = level
            //     this.optTestLevelId = newId
            //     this.optTextLevelLabel = ''
            // },
            getTestLevelTree(id,callBack){
                let bookCatalogId = this.catalogId;//this.$route.query.catalogId
                getTestLevelTree(bookCatalogId)
                    .then((res) => {console.log(res);
                        if (res["code"] == 0) {
                            //TODO 加载树
                            this.testLevelTreeData = res["data"]
                            
                            this.$refs.testLevelTreeRef.updateTreeData(this.testLevelTreeData,id);
                            if(res["data"].length>0){
                                this.topLevel = res["data"][0].lvl
                            }else{
                                this.topLevel = 0;
                            }
                            if(callBack && this.testLevelTreeData.length){
                                callBack();
                            }
                        }
                    })
                    .catch((err) => {
                        this.$message.error("加载树成功！");
                    });
            },
            // 广度优先--暂时未用到
            treeForeach (tree, func) {
                let node, list = [...tree]
                while (node = list.shift()) {
                    func(node)
                    node.children && list.push(...node.children)
                }
            },
            // treeForeach (tree, func) {   //深度优先遍历
            //     tree.forEach(data => {
            //         func(data)
            //         data.children && this.treeForeach(data.children, func) // 遍历子树
            //     })
            // },
            deleteTestLevel(id) {
                //页面删除需要先判断是否是刚新增的，如果刚新增的直接删除，不如不是，则去后台删除
                let node = this.$refs.testLevelTreeRef.getNode(id);
                // this.$refs.testLevelTreeRef.remove(node);
                this.treeNodeRenaming = false
                this.nodeEdit = false
                this.isEmpty = true;    //删除节点后关闭试卷显示暂无数据
                this.isOperate = false
                if (!node.id) {
                    this.$refs.testLevelTreeRef.remove(node,()=>{
                        this.topLevel=0
                    });
                    return
                }
                delTestLevel(id).then((res) => {
                	if (res["code"] == 0) {
                        this.$message.success("删除成功！");
                		//TODO 从树上移除该节点
                		this.$refs.testLevelTreeRef.remove(node,()=>{
                            this.topLevel=0
                        });
                	} else {
                		this.$message.error("删除失败");
                	}
                })
                .catch((err) => {
                    this.$message.error("删除失败！");
                });
            },
            // 新增专项套卷
            addSpecialCoilingHandle() {
                let params = {
                    bookId: this.$route.query.bookId,
                    spBookId:  this.$route.query.bookId,
                    catalogType: this.$route.query.questionSource,
                    subType : this.$route.query.type,
                    name: this.optTextLevelLabel,
                    paperLvlId: this.optTestLevelId
                };
                console.log(params)
                addRefiningCoiling(params)
                    .then((res) => {
                        if (res["code"] == 0) {
                            console.log("addCoilingHandle res", res);
                            this.coilingId = res["data"]["id"]
                            this.$message.success("新增听说精炼套卷成功！");
                            EventBus.$emit("addCoilingHandle", this.coilingId);
                            this.getCoiling(()=>{    //创建试卷后更新树结构
                                this.getTestLevelTree(this.coilingId);
                            });
                            // let node = this.$refs.testLevelTreeRef.getNode(this.optTestLevelId);
                            // this.$set(node.data, 'isEdit', false)
                            this.treeNodeRenaming = false
                        } else {
                            this.$message.error("新增听说精炼套卷失败！");
                        }
                        // this.getTestLevelTree();//重新刷新树结构
                        this.isOperate=false
                    })
                    .catch((err) => {
                        console.log("addCoilingHandle err", err);
                        this.$message.error("新增听说精炼套卷失败！");
                        this.getTestLevelTree();//重新刷新树结构
                        this.isOperate=false
                    });
            },
            setInsertLeve(data){
                this.showLevelArr = [];
                if(data.children){
                    if(data.children.length>0){
                        // this.childLevel = data.children[0].lvl;
                        this.showLevelArr.push(data.children[0].lvl);
                    }else{
                        // this.childLevel = data.lvl+1
                        for(let i=data.lvl+1;i<=4;i++){
                            this.showLevelArr.push(i);
                        }
                    }
                }else{
                    this.childLevel = data.lvl+1
                    for(let i=data.lvl+1;i<=4;i++){
                        this.showLevelArr.push(i);
                    }
                }
                this.showLevelArr.push(data.lvl);
                this.optTestLevel = data.lvl


                // optTextLevelLabel
                this.treeNodeRenaming = true;
                this.optTestLevel = data.lvl
                this.optTestLevelId = data.id
                this.optTextLevelLabel = data.name
            },
            testLevelNodeClick(node, target) {console.log(node,this.coilingId,this.treeNodeNum);
                if(this.treeNodeNum != node.id){
                    this.isOperate = false
                }
                this.treeNodeNum = node.id;
                this.setInsertLeve(node)
                // if(node.paperId==this.coilingId){

                //     return;
                // }
                if(node.paperId==null){    //当paperId为null时，此时数据为空，不进行查询
                   this.coilingId = node.paperId
                   EventBus.$emit("addCoilingHandle", this.coilingId);
                //    EventBus.$emit("refreshPageData", '');
                   EventBus.$emit("resethData", '');
                   this.isEmpty =  true;
                   return;
                }else{
                    //当paperId有值时，此时数据不为空，进行查询
                    this.isEmpty =  false;
                
                
                    this.coilingId = node.paperId
                    EventBus.$emit("addCoilingHandle", this.coilingId);
                    //this.$emit("getCollectionStatus", id);
                    
                    // this.$store.commit('coilingIdChange',this.coilingId)
                    // EventBus.$emit("addSaveBtnLock");   //给保存按钮加锁
                }
            }
            
		},
		mounted() {
        let _this = this;
        // 监听点击空白事件 ，服务于 点击出菜单
        document.addEventListener("click", this.monitoringClick.bind(this));          
        window.addEventListener("scroll", this.handleScroll)
        
        this.bookId = this.$route.query.bookId;
        this.catalogId = this.$route.query.catalogId;

        let address = this.address = this.$route.query.region;

        let { questionSource, type } = this.$route.query;
        // this.dialogTitle = "收藏夹("
        // if(type){
        //     this.dialogTitle += `${type}-`;
        // }
        // this.dialogTitle += `${questionSource}-${address})`

        this.dialogTitle = `收藏夹(${address})`;

        EventBus.$on("addFieldFromCollect", this.addFieldFromCollect);
        EventBus.$on("addFieldFromFlow", this.addFieldFromFlow);
        EventBus.$on("scjShow", this.scjShow);
        EventBus.$on("deleteTestLevel", this.deleteTestLevel);
        this.getTestLevelTree('',function(){    //默认选中第一个节点
            _this.$refs.testLevelTreeRef.checkNode('',_this.testLevelTreeData[0],0)
        })
        EventBus.$emit("getType", 'special');
        EventBus.$on("contentChangeIdUn", this.contentChangeIdUn);
        EventBus.$on("contentChangeIdEnd", this.contentChangeIdEnd);
    },
    beforeDestroy() {
        document.removeEventListener("click", this.monitoringClick.bind(this));
        window.removeEventListener("scroll", this.handleScroll)
        
        EventBus.$off("addFieldFromCollect", this.addFieldFromCollect);
        EventBus.$off("addFieldFromFlow", this.addFieldFromFlow);
        EventBus.$off("scjShow", this.scjShow);
        EventBus.$off("deleteTestLevel", this.deleteTestLevel);
        EventBus.$off("contentChangeIdUn", this.contentChangeIdUn);
        EventBus.$off("contentChangeIdEnd", this.contentChangeIdEnd);
    },   
};
</script>
<style lang="scss" scoped>
@import "../components/testContent/addFields/AddFields.css";


.stems {
    width: 100%;
    height: 90vh;
    background: #fff;
    border-radius: 12rem;
    box-sizing: border-box;
    padding: 84rem 20rem 20rem;
    position: relative;

    .index_dia {
        border-radius: 4rem;

        .dia_item {
            margin: auto;
            width: 400rem;
        }
    }
}
.unsaved {
  width: 8rem;
  height: 8rem;
//   position: absolute;
//   right: -1rem;
//   top: 1rem;
  line-height: 14rem;
  font-size: 14rem;
  color: #ff0000;
}
.dialog {
    :deep .el-dialog__body {
        padding: 0 30rem;
    }
}

.elDialog {
    :deep .el-dialog__body {
        padding: 0 30rem;
    }

    ::v-deep .el-dialog {
        border-radius: 10rem;
        // height: 367rem;
        padding-bottom: 20rem;
        background: #f5f5f5;
    }

    :deep .el-tabs__item {
        padding: 6rem 16rem !important;
        height: auto;
        line-height: normal;
        color: #303133;
        background: #E4E4E4;
        border-radius: 6rem;
        margin-right: 20rem;
    }

   ::v-deep.el-tabs__item:hover:not(.is-active) {
        color: #07b972;
    }

   ::v-deep.el-tabs__nav-wrap::after {
        height: 0;
    }

   ::v-deep.el-tabs__active-bar {
        width: 0 !important;
    }

    :deep .el-tabs__item.is-active {
        color: #fff;
        background: linear-gradient(to right, #09b17e, #08c162);
    }

    ::v-deep .el-dialog__title {
        padding-left: 26rem;

        &:before {
            content: "";
            position: absolute;
            left: 30rem;
            top: 22rem;
            width: 5rem;
            height: 20rem;
            border-radius: 10rem;
            background-color: var(--primary-color);
        }
    }

    .el-dialog {
        .el-form {
            height: 183rem;
            background: #fff;
            margin: 0 auto;
            padding: 20rem;
            border-radius: 6rem;
        }

        .el-button {
            float: right;
            width: 76rem;
            height: 32rem;
            position: relative;
            top: 20rem;
            font-size: 16rem;
            color: #fff;
            background: var(--primary-color);
            border: none !important;
        }
    }

    ::v-deep .el-dialog {
        display: flex;
        flex-direction: column;
        margin: 0 !important;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
}

.addressFilter {
    height: 40rem;
    position: absolute;
    top: 19rem;
    width: calc(100% - 56rem);
}

.coiling {
    height: 50rem;
    position: absolute;
    top: 64rem;
    width: calc(100% - 16rem);
}

.content {
    width: 100%;
    height: 100%;

    border-radius: 3rem;
    display: flex;
    justify-content: space-between;
    
    .contentProcessBox{
        // width:calc(100% - 320rem);
        width:calc(100% - 260rem);
        display: flex;
        justify-content: space-between;
    }
    .noData{
        // width:calc(100% - 320rem);
        width:calc(100% - 260rem);
        height:100%;
        background: #f5f5f5;
        box-sizing: border-box;
        border-radius: 12rem;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .testLevel {
        // width: 300rem;
        width: 240rem;
        height: 100%;
        
        .testContentBox {
        	width: 100%;
        	height: 100%;
        	box-sizing: border-box;
        	padding: 20rem 0;
        	border-radius: 12rem;
        	background: #f5f5f5;
        
        
        	.el-container-box {
        		height: 100%;
        		box-sizing: border-box;
        		padding-top: 56rem;
        		position: relative;
                display: flex;
                justify-content: space-between;
        	}
        
        	.el-container {
        		height: 100%;
        		box-sizing: border-box;
        	}
        
        	.el-header {
        		padding: 0;
        		height: 36rem !important;
        		position: absolute;
        		top: 0;
        		width: 100%;
        		display: flex;
        		flex-direction: row;
        		justify-content: space-between;
        		align-items: center;
        	}
        
        	.el-aside {
        		background: #fff;
        		padding-top: 37rem;
        		position: relative;
        		overflow: hidden;
        		width: 144rem !important;
        		border-radius: 6rem;
        		padding-bottom: 15rem;
        		padding-right: 5rem;
        		padding-left: 17rem;
        		border: 1rem dashed #b1b1b1;
        		margin-right: 20rem;
        
        		>p {
        			position: absolute;
        			top: 0;
        			left: 0;
        			width: 100%;
        			height: 37rem;
        			font-size: 12rem;
        			color: #303133;
        			text-align: center;
        			line-height: 36rem;
        			font-weight: 600;
        		}
        	}
        
        	.el-main {
        		overflow: inherit;
        		background-color: #fff;
        		border-radius: 6rem;
        		padding: 19rem 5rem 12rem 0;
        	}
        
        	.coilingBtn {
        		display: flex;
        		flex-direction: row;
        		align-items: center;
        	}
        }
    }

    .testContent {
        width: calc(56.2% - 20rem);
        height: 100%;
    }

    .answeringProcess {
        width: 43.8%;
        height: 100%;
    }
}

.starDia {
    ::v-deep .el-dialog__title {
        padding-left: 20rem;
        position: relative;

        &:before {
            content: "";
            position: absolute;
            left: 0rem;
            top: 0rem;
            bottom: 0;
            margin: auto;
            width: 5rem;
            height: 20rem;
            border-radius: 10rem;
            background-color: var(--primary-color);
        }
    }

    ::v-deep .el-dialog {
        border-radius: 10rem;
        //height: 800rem;
        padding-bottom: 20rem;
        background: #f5f5f5;
    }

   ::v-deep.el-checkbox__input.is-checked .el-checkbox__inner,
   ::v-deep.el-checkbox__input.is-indeterminate .el-checkbox__inner {
        background-color: #07b972;
        border-color: #07b972;
    }

    /*::v-deep.el-input__inner {
		border-right: none;
	} */

    /*::v-deep.el-input-group__append {
		background: #fff;
		border-left: none;
	} */

    .search-icon {
        font-size: 18rem;
        cursor: pointer;
    }

    .el-dialog__header,
    .el-dialog__title {
        background: #f9fcf8;
    }

    .btn {
        background-color: #07b972;
        padding: 10rem 20rem;
        text-align: center;
        color: #fff;
        border-radius: 5rem;
        cursor: pointer;
    }

    .btn_disabled {
        background-color: #B4B4B4;
        padding: 10rem 20rem;
        text-align: center;
        color: #FFF;
        border-radius: 5rem;
        cursor: not-allowed;
    }

    .info-t {
        width: 100%;
    }

    .out {
        display: flex;
        height: 650rem; //430

        .mes-l {
            border-radius: 5rem 0 0 5rem;
            border: 1rem solid #ccc;
            //border-right: 0rem;
            background: #fff;
            height: 648rem;
            width: 300rem;
            overflow-y: auto;
            border-right: none;

            .search-container {
                display: flex;
                align-items: center;
                padding: 10rem;

                .el-input {
                    width: 320rem;
                    // height: 30rem !important;
                }
            }
        }

        .mes-r {
            border: 1rem solid #ccc;
            border-radius: 0 5rem 5rem 0;
            width: 900rem;

            .r-t {
                min-width: 900rem;
                height: 596rem;
                overflow-y: auto;
                background: #fff;
                border-radius: 0 5rem 5rem 0;

                .rt-item {
                    width: calc(100% - 22rem) !important;
                    display: flex;
                    border: 1rem solid #ccc;
                    border-radius: 5rem;
                    margin-left: 10rem;

                    .item-tit {
                        background: #07b972;
                        color: #fff;
                        border-radius: 5rem 0 0 5rem;
                        height: 80rem;
                        padding: 0 10rem;
                        line-height: 80rem;
                    }

                    .item-info {
                        padding-left: 5rem;
                        width: 100%;
                        display: flex;
                        flex-direction: column;
                        justify-content: space-around;
                    }
                }
            }

            .r-b {
                padding: 5rem;
                display: flex;
                justify-content: space-between;
                align-items: center;
                border-top: 1rem solid #ccc;
            }
        }
    }
}

.favorite {
    position: absolute;
    left: 0;
    bottom: 10%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: #fdba03;
    padding: 10rem;
    border-radius: 50%;
    font-size: 12rem;
    color: #fff;
    cursor: pointer;
}

.progress_item_head {
    padding: 10rem;

    .name_ipt {
        width: 140rem;
        color: aqua;

        ::v-deep .el-input__inner {
            border: none;
            padding: 0rem;
            height: 1em;
            font-size: 18rem;
            color: #000000;
            background: transparent;
        }
    }

   ::v-deep.el-checkbox__input.is-checked .el-checkbox__inner,
   ::v-deep.el-checkbox__input.is-indeterminate .el-checkbox__inner {
        background-color: #ffb802;
        border-color: #ffb802;
    }

   ::v-deep.is-checked .el-checkbox__inner:after {
        border-color: #fff;
    }

    .timer {
        color: brown;
        transform: scale(0.5, 0.5);
    }

    .time_ipt {
        width: 61rem;
        border-radius: 6rem;

        ::v-deep .el-input__inner {
            height: 24rem;
            padding: 10rem;
            background: transparent;
        }

        ::v-deep .el-input__inner:focus,
        ::v-deep .el-input__inner:hover {
            border-color: #E9E9E9;
        }
    }
}

.uploadImg0 {
    height: 0rem;
}
.uploadImg{
    width: 100%;
    border-top: 1rem solid #E9E9E9;
}
.uploadImgBorder {
    border-top: 1rem solid #e9e9e9;
}

/* 88888888888888 */
.progress_item {
    border: 1rem solid #E9E9E9;
    border-radius: 6rem;
    position: relative;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    padding: 5rem 20rem 15rem 12rem;

    .progress_id {
        font-size: 12rem;
        color: #666666;
        display: flex;
        white-space: nowrap;
        align-items: center;
       ::v-deep.el-input__inner{
            width: 100rem;
            border: none;
            
        }
    }

    .progress_item_head {
        display: flex;
        align-items: center;

        .progress_count {
            margin-right: 5rem;
        }

        .name_ipt {
            width: 140rem;
            color: aqua;

            ::v-deep .el-input__inner {
                border: none;
                padding: 0rem;
                height: 1em;
                font-size: 18rem;
                color: #000000;
                background: transparent;
            }
        }

        .spanText {
            font-size: 12rem;
            position: absolute;
            left: 0;
            padding: 0 15rem;
            white-space: nowrap;
            visibility: hidden;
        }

        .timer {
            color: brown;
            transform: scale(0.5, 0.5);
        }

        .time_ipt {
            width: 61rem;
            border-radius: 6rem;

            ::v-deep .el-input__inner {
                height: 24rem;
                padding: 10rem;
                background: transparent;
            }

            ::v-deep .el-input__inner:focus,
            ::v-deep .el-input__inner:hover {
                border-color: #E9E9E9;
            }
        }

        .link_add {
            position: absolute;
            right: 0rem;

            .el-button {
                border: none;
                font-size: 14rem;
                color: var(--primary-color);
                background: transparent;

                img {
                    margin-right: 5rem;
                }
            }

            div {
                display: flex;
                align-items: center;
            }


        }
    }

    .progress_item_audio {
        display: flex;
        // width: 60%;
        align-items: center;
        height: 30rem;
        font-size: 14rem;

        span {
            width: 35rem;
        }

        p {
            margin-left: 10rem;
            width: 35rem;
            font-size: 14rem;
            color: #666666;
            cursor: pointer;
        }

        .upload_btn {
            border: none;
            font-size: 14rem;
            color: #666666;
            width: 50rem;
        }

        .audio_item {
            margin-left: 10rem;
            display: flex;
            align-items: center;
            width: 60rem;
            justify-content: space-around;
        }

        .play_times {
            .el-button {
                padding: 2rem;
                margin-left: 4rem;
                width: 80rem;
                border: none;
                // height: 1em;
                color: #666666;
                background: transparent;
            }
        }

        .play_setting {
            width: auto;

            .el-button {
                padding: 2rem;
                margin-left: 4rem;
                width: 30rem;
                // height: 1em;
                border: none;
                color: #666666;
                background: transparent;
            }
        }
    }

    .progress_item_show {
        display: flex;
        width: 100%;
        font-size: 14rem;

        .del_diy {
            cursor: pointer;
            margin-left: 8rem;
            color: #777;
        }

        .showLeft {
            width: 36rem;
            line-height: 36rem
        }

        .showRight {
            width: 100%;
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            flex: 1;

            .el-input {
                width: 85rem;
                border-radius: 6rem;
                padding-left: 10rem;
                margin: 6rem 0rem 6rem 0rem;

                ::v-deep .el-input__inner {
                    height: 24rem;
                    background: transparent;
                }

                ::v-deep .el-input__inner:focus,
                ::v-deep .el-input__inner:hover {
                    border-color: #FFB802;
                }

                .el-icon-error {
                    color: #FF0000;
                    position: absolute;
                    cursor: pointer;
                    top: -4rem;
                    right: -10rem;
                    width: 16rem;
                    height: 16rem;
                    display: none;
                }

                .el-icon-error-focus {
                    display: block;
                }
            }
            
            ::v-deep .el-input__inner {
                padding: 0rem 5rem;
            }

            img {
                transform: scale(0.5, 0.5);
                // margin-bottom: 10rem;
            }
        }

        ::v-deep .el-input--suffix .el-input__inner {
            padding-right: 5rem;
            padding-left: 5rem;
        }


    }

    .progress_item_input {
        font-size: 14rem;
        display: flex;

        .input_left {
            width: 36rem;
            line-height: 24rem
        }

        .input_right {
            width: 100%;
            display: flex;
            align-items: center;
            flex-wrap: wrap;

            margin-top: 4rem;

            .el-input {
                width: 106rem;
                // margin-bottom: 4rem;
                margin-left: 10rem;
                position: relative;

                ::v-deep .el-input__inner {
                    margin-left: 30rem;
                    width: 74rem;
                    height: 24rem;
                }

                ::v-deep .el-input__inner:focus,
                ::v-deep .el-input__inner:hover {
                    border-color: #FFB802;
                }

                .el-icon-error {
                    color: #FF0000;
                    position: absolute;
                    cursor: pointer;
                    top: -4rem;
                    right: -10rem;
                    width: 16rem;
                    height: 16rem;
                    display: none;
                }

                .el-icon-error-focus {
                    display: block;
                }

                ::v-deep .el-input-group__prepend {
                    position: absolute;
                    top: -1rem;
                    padding: 0rem;
                    width: 32rem;
                    height: 24rem;
                    text-align: center;
                    background: #FFB802;
                    color: #FFFFFF;
                }
            }

            .input_prepend {

                display: inline-block;
                line-height: 24rem;
            }

            .input_prepend:empty::before {
                content: attr(placeholder);
                color: #fff;
            }

            [contenteditable]:focus {
                outline: none;
            }

            ::v-deep .el-input--suffix .el-input__inner {
                padding-right: 0rem;
            }

            ::v-deep .el-input--suffix .el-input__inner {
                padding-right: 5rem;
                padding-left: 5rem;
            }

            .el-input:nth-child(n) {
                margin: 3rem 0rem 3rem 10rem;
            }

            img {
                transform: scale(0.5, 0.5);
            }
        }
    }

    .progress_item_option {
        margin-top: 5rem;
        font-size: 14rem;
        display: flex;

        .operation {
            width: 50rem;
            line-height: 24rem
        }

        .operation_right {
            width: 100%
        }

        .skip {
            width: 45rem;
            line-height: 24rem
        }

        .el-checkbox-group {
            display: inline;

            .el-checkbox {
                // margin: 0rem 10rem 0rem 0rem;

            }
        }

        ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
            background-color: #FFB802;
            border-color: #FFB802;
        }

        ::v-deep .el-checkbox__input .el-checkbox__inner:hover,
        ::v-deep .el-checkbox__input.is-focus .el-checkbox__inner {
            border-color: #FFB802;
        }

        ::v-deep .el-checkbox__input.is-checked+.el-checkbox__label {
            color: #303133;
        }
        
        //被选中且禁用状态下打勾颜色
        ::v-deep .el-checkbox.is-disabled.is-checked .el-checkbox__inner::after {
          border-color: #fff;
        }

        ::v-deep .el-checkbox__label {
            color: #A8ABB2;
            ;
        }

    }

    .jump_step {
        line-height: 28rem;

        .progress_step {
            display: flex;

            ::v-deep.el-select {
                margin-left: 5rem;
                width: 80rem;

                .el-input__suffix {
                    display: none;
                }

                .el-input__inner {
                    border: none;
                }
            }
        }
    }



    ::v-deep .el-dialog {
        border-radius: 10rem;
        width: 400rem;
        height: 200rem;
        background: #F5F5F5;

        p {
            font-size: 14rem;

            margin-bottom: 20rem;
        }

    }

    ::v-deep .el-dialog__body {
        // padding: 0rem;
        padding-top: 10rem;
        padding-left: 30rem;
        // margin: 0rem;
    }

    ::v-deep .el-dialog__title {
        padding-left: 10rem;

        &:before {
            content: '';
            position: absolute;
            left: 20rem;
            top: 22rem;
            width: 5rem;
            height: 20rem;
            border-radius: 10rem;
            background-color: var(--primary-color);
        }

    }

    ::v-deep .el-dialog__header .el-dialog__close:hover {
        color: var(--primary-color) !important;
    }
}

.link_add_dropdown {
    .el-dropdown-menu__item {
        width: 56rem;
    }
}

.play_times_dropdown .el-dropdown-menu__item,
.play_setting_dropdown .el-dropdown-menu__item {
    width: 30rem;
}


.el-dropdown-menu__item {
    font-size: 14rem;
    // height: 35rem;
    position: relative;

    // width: 60rem;
    .upload_btn {
        position: absolute;
        top: 0rem;
        left: 4rem;
        width: 40rem;
        background: transparent;
        border: none;
        font-size: 14rem;
    }

    .upload_btn:hover {
        display: inline-flex;
        height: 1em;
        color: var(--primary-color);
        background-color: #d5fae0;
    }
}

.el-dropdown-menu__item:hover {
    color: var(--primary-color);
    background-color: #d5fae0;
}

::v-deep .el-loading-spinner .el-icon-loading,
::v-deep .el-loading-spinner .el-loading-text {
    color: var(--primary-color);
}

.input_disable {

    // 输入框失效样式
    ::v-deep .el-input__inner {
        border-color: #FF0000;
        color: #FF0000;
        background: #F7E8E8;
    }

    ::v-deep .el-input__inner::placeholder {
        color: #FF0000;
    }

    &::after {
        content: '\5df2\5931\6548';
        color: #FF0000;
        font-size: 10rem;
        position: absolute;
        left: 10rem;
        top: 22rem;
    }
}

.fieldsContentSelect {
    /* 输入框的样式表 */
    .no-scroll {
      overflow: hidden;
      /* 禁用滚动条 */
      resize: none;
      /* 禁止用户手动调整文本框的尺寸 */
      height: auto !important;
      /* 强制将高度设置为自适应 */
      max-height: none !important;
      /* 禁用最大高度限制 */
    }
    
    ::v-deep .el-textarea__inner {
      border: none;
      padding: 6rem 15rem 6rem 12rem;
      font-weight: inherit;
    }
    
    ::v-deep .el-textarea__inner::-webkit-scrollbar {
      width: 103rem;
      /* 设置滚动条宽度 */
    }
}

.idTextInput {
    width: 36rem;

    :deep .el-input__inner {
        padding: 0 3rem !important;
        border: 1rem solid rgba(0, 0, 0, 0);
    }

    :deep .el-input__inner:focus {
        border: 1rem solid #dcdfe6;
    }
    
}

.testLevelTree {
    ::v-deep    .el-tree {
        width: 100%;
    }
    
    // 一级
    ::v-deep    .el-tree > .el-tree-node > .el-tree-node__content .el-tree-node__expand-icon{
        color:#FA80C6;
    }
    
    ::v-deep    .el-tree > .el-tree-node:focus > .el-tree-node__content .el-tree-node__expand-icon{
        color:pink;
    }
    
    // 二级
    ::v-deep    .el-tree > .el-tree-node> .el-tree-node__children > .el-tree-node > .el-tree-node__content .el-tree-node__expand-icon{
        color:#3987EF;
    }
    
    // 三级
    ::v-deep    .el-tree > .el-tree-node> .el-tree-node__children > .el-tree-node > .el-tree-node__children > .el-tree-node > .el-tree-node__content .el-tree-node__expand-icon{
        color:#FCCA00;
    }
    
    //四级
    ::v-deep    .el-tree > .el-tree-node> .el-tree-node__children > .el-tree-node > .el-tree-node__children > .el-tree-node > .el-tree-node__children > .el-tree-node > .el-tree-node__content .el-tree-node__expand-icon{
        color:#333333;
    }
}
.treeNodeName{
  overflow: hidden; /* 确保超出容器的内容被裁剪 */
  white-space: nowrap; /* 确保文本在一行内显示 */
  text-overflow: ellipsis; /* 超出部分显示省略号 */
//   width: 100%;
    width: calc(100% - 50rem);
    position: relative;
}
.treeNodeBox{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
}
.treeNodeEdit {
    display: inline-block;
    width: calc(100% - 16rem);
    border: 2rem solid #0BAE6A;
    // flex: 1;
}
.treeNodeEdit:focus {
    border: 2rem solid #0BAE6A;
}
.optFields {
    display: inline-block;
    margin-left: 5rem;
    width: 16rem;
    height: 16rem;
    background: url('../assets/images/icon-operation.png') no-repeat;
    background-size: 16rem 16rem;
    background-position: bottom;
    cursor: pointer;
}
.operateBox {
  width: 132rem;
  position: fixed;
  z-index: 2;
  background: #fff;
  border: 1rem solid rgba(0, 0, 0, 0.15);
  border-radius: 4rem;
}

::v-deep .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content {
    background-color: lightgreen;
}
.operateTwo{
    position: absolute;
    top: 30rem;
    /* width: 100px;
    height: 100px; */
    /* background: red; */
    width: 70rem;
    background: white;
    /* right: 15rem; */
    padding: 10rem;
    left: 0;
    z-index: 99;
}
.tree-node-label{
    width: calc(100% - 95rem);
    overflow: hidden; /* 确保超出容器的内容被裁剪 */
    white-space: nowrap; /* 确保文本在一行内显示 */
    text-overflow: ellipsis; /* 超出部分显示省略号 */
}
</style>

<style>
/* 公共标题样式 */
.coilingTitle {
    font-size: 16rem;
    font-weight: 600;
    color: #333;
    padding-left: 16rem;
    position: relative;
    height: 32rem;
    line-height: 32rem;
    display: flex;
    flex-direction: row;
    align-self: center;
}

.coilingTitle:before {
    content: "";
    position: absolute;
    left: 0rem;
    top: 6rem;
    width: 5rem;
    height: 20rem;
    border-radius: 10rem;
    background-color: var(--primary-color);
}

.el-select-dropdown__item.selected {
    color: #08c162;
}

.el-select-dropdown__item:hover {
    color: #0bae6a;
    background: #d5fae0;
}

.el-input-group__append:hover {
    border: 1rem solid blue;
    /* 你想要的样式 */
}
.levelBtnBox{
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 0 15rem;
}
.addLevelBtn {
    color: #0BAE6A;
    font-size: 14rem;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    position: relative;
    cursor: pointer;
}
.addLevelBtn img{
    height: 14rem;
    width: 14rem;
    margin-right: 6rem;
}

.operateList{
    padding: 5rem;
    cursor: pointer;
}
.operateList:hover{
    background: #D5FAE0;
}
/*以下为流程样式 */

.quill_edit_box{
    position: relative;
}
.quill_edit_mask{
    position:absolute;
    width:100%;
    height:100%;
    z-index:999
}
</style>